import styled, { css } from 'styled-components';

import { DefaultLayoutProps } from './DefaultLayout';

export const LayoutContent = styled.div<
    Required<Pick<DefaultLayoutProps, 'contentPadding'>>
>(
    ({ contentPadding }) => css`
        padding-top: ${contentPadding.top}px;
        padding-bottom: ${contentPadding.bottom}px;
    `,
);
